import { gql } from '@apollo/client';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import CLASSROOM_LICENSE_USAGE_FRAGMENT from 'graph/fragments/classroom-license-usage';
import CLASSROOM_USER_ENROLLMENT_FRAGMENT from 'graph/fragments/classroom-user-enrollment';
import CLASSROOM_STATS_FRAGMENT from 'graph/fragments/classroom-stats';

const GET_USER_CLASSROOMS = gql`
  query getUserClassrooms($userId: Int!) {
    classrooms(whereUser: { id: [$userId] }, orderBy: { field: NAME, direction: ASC }) {
      ...BaseClassroom
      users {
        ...BaseClassroomUserEnrollment
      }
      stats {
        ...BaseClassroomStats
      }
      licenseUsage {
        ...BaseClassroomLicenseUsage
      }
      organization {
        id
        name
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
  ${CLASSROOM_STATS_FRAGMENT}
  ${CLASSROOM_USER_ENROLLMENT_FRAGMENT}
  ${CLASSROOM_LICENSE_USAGE_FRAGMENT}
`;

export default GET_USER_CLASSROOMS;
